<cap-input [formControl]="formControl" [filter]="to.keyFilter" [placeholder]="to.readonly ? '' : to.placeholder">
</cap-input>
